module.exports = __webpack_public_path__ + "img/loading-spinner.49daf65.svg";